import {http_client} from '@/plugins/http_client'
import router from "@/router";
import store from '@/store'
import Vue from "vue";

const nextStepper = ({commit, state}) => {
    commit('nextStepper', ++state.stepper_value)
}

const backStepper = ({commit, state}) => {
    commit('backStepper', --state.stepper_value)
}

const showCreatePerson = ({commit}) => {
    commit('setShowCreatePerson', true)
}
const hideCreatePerson = ({commit}) => {
    commit('setShowCreatePerson', false)
}

const setPorcentaje = ({commit}, payload) => {
    commit('setPorcentaje', payload)
}

const guardarProyectoDocs = async ({commit, state, dispatch}) => {
    store.dispatch('utils/showLoader')
    let method = 'post'
    let url = '/api/v1/proyecto'
    let data = {
        nombre: state.form_proyecto.nombre_proyecto.value,
        id_institucion: Number(state.form_proyecto.institucion.value),
        id_propiedad_tierra: Number(state.form_proyecto.tenencia_tierra.value),
        id_tipo_proyecto: Number(state.form_proyecto.tipo_proyecto.value),
        direccion: state.form_proyecto.direccion_extra.value,
        id_responsable: Number(state.form_proyecto.id_responsable.value),
        id_project_request: state.form_proyecto.id_project_request.value,
        plazo_estimacion: Number(state.form_proyecto.plazo_estimacion.value)

    }



    if (state.form_proyecto.id.value) {
        method = 'post'
        url = `/api/v1/proyecto/${state.form_proyecto.id.value}`
        delete data.id_institucion
    }
    try {
        let form = new FormData();

        Object.keys(data).forEach(item => {
            form.append(item, data[item]);
        })



        form.append('poligono',JSON.stringify(state.form_proyecto.lat_lng.value));

        const headers = {'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'}
        form.append('carta_file', state.archivoDUI);

        const response = await http_client(url, form, method, headers)



        commit('setIdProyecto', response.data.id)
        commit('setIdEstado', response.data.id_estado)
        dispatch('saveEmailResponsable', data.id_responsable)
        dispatch('nextStepper')
    } catch (e) {
        store.dispatch('utils/hideLoader')
        if (e.response.status === 303) {
            Vue.$toast.warning('El proyecto ya existe')
            // dispatch('utils/temporalAlert', {
            //     show: true,
            //     type: 'warning',
            //     message: 'El proyecto ya existe'
            // }, {root: true})
        } else if (e.response.status === 400) {
            Vue.$toast.error('Información enviada no valida')
            // dispatch('utils/temporalAlert', {
            //     show: true,
            //     type: 'danger',
            //     message: 'Informacion enviada no valida'
            // }, {root: true})
        }
    }
}

const getEmailResonsable = async ({commit}, id_responsable) => {
    const response = await http_client(`/api/v1/personas/${id_responsable}/contactos`, {
        id_tipo_contacto: 2
    })
    if (response.data.length > 0) {
        commit('setIdAndContactCorreoResponsable', {
            id: response.data[0].id,
            contacto: response.data[0].contacto
        })
    }
}

const saveEmailResponsable = async ({commit, state, dispatch}) => {
    try {
        let url = `/api/v1/personas/${state.form_proyecto.id_responsable.value}/contactos`,
            method = 'post',
            data = [{
                "id_tipo_contacto": 2,
                "contacto": state.form_proyecto.correo_electronico.contacto
            }]
        if (state.form_proyecto.correo_electronico.id_contacto) {
            url = `/api/v1/personas/${state.form_proyecto.id_responsable.value}/contactos/${state.form_proyecto.correo_electronico.id_contacto}`
            method = 'put'
            data = data[0]
            data.activo = true
        }
        const response = http_client(url, data, method)
    } catch (e) {
        if (e.response.status === 400) {
            Vue.$toast.warning('Información no valida')
            // dispatch('utils/temporalAlert', {
            //     show: true,
            //     message: 'Informacion no valida',
            //     type: 'warning'
            // }, {root: true})
        } else if (e.response.status === 403) {
            Vue.$toast.warning('No Tiene permiso de crear o modificar correos de responsable')
            // dispatch('utils/temporalAlert', {
            //     show: true,
            //     message: 'No Tiene permiso de crear o modificar correos de responsable',
            //     type: 'warning'
            // }, {root: true})
        }
    }
}

const getProyecto = async ({commit, state, dispatch}, id_proyecto) => {
    try {
        const response = await http_client(`/api/v1/proyectos/${id_proyecto}`)
        const data = response.data
        commit('setProyectoData', data)
        commit('setAlcaldiaProyecto', data.institucion.id)
        commit('setTipoInstitucion', data.institucion.id_tipo_institucion)
        commit('setNameInstitucion', data.institucion.institucion)

        commit('setDepartamento', data.institucion.id_departamento)
        commit('setProyectoNombre', data.nombre)
        commit('setFotoDui', data.foto_dui)
        commit('setDuiDoc', data.dui_doc)
        commit('setTipoProyecto', data.id_tipo_proyecto)
        commit('setDireccionProyecto', data.direccion)
        commit('setTenenciaTierraProyecto', data.id_propiedad_tierra)
        commit('setDuiResponsableProyecto', data.responsable.dui)
        commit('setIdProcessMethod', data.idProccessMethod)
        commit('setIdProcessMethodType', data.idProccessMethodType)
        commit('setProjectRequest', data.id_project_request)
        commit('setPlazoEstimacion', data.plazo_estimacion)
        commit('setCostoTotalPresupuestado', data.costo_total_presupuestado)
        commit('setIdEstado', data.id_estado)
        commit('setIdVerificationReception', data.id_verification_reception)
        commit('setIdVerificationCost', data.id_verification_cost)
        commit('setIdNombreResponsable', {
            id_responsable: data.responsable.id,
            nombre_responsable: data.responsable.primer_nombre + ' ' + data.responsable.segundo_nombre
        })
        await dispatch('getEmailResonsable', data.responsable.id)
        commit('setearLatLng', data.poligono)
    } catch (e) {
        if (e.response.status === 403) {
            Vue.$toast.warning('No tiene permiso para realizar esta acción')
            // dispatch('utils/temporalAlert', {
            //     show: true,
            //     type: 'warning',
            //     message: 'No tiene permiso para realizar esta acción'
            // }, {root: true})
            router.push('/proyectos/list')
        } else if (e.response.status === 404) {
            Vue.$toast.warning('Recurso no encontrado')
            // dispatch('utils/temporalAlert', {
            //     show: true,
            //     type: 'warning',
            //     message: 'Recurso no encontrado'
            // }, {root: true})
        }
    }
}


const getPlazos = async ({commit}) => {
    const response = await http_client('/api/v1/proyectos/plazo-estimaciones')
    commit('setPlazos', response.data)
}

const changeStateProyect = async ({state}, estado) => {
    try {
        await http_client(`/api/v1/proyectos/${state.form_proyecto.id.value}/estados`, {
            id_estado: Number(estado)
        }, 'post')
        Vue.$toast.success('Procesado')
        // store.dispatch('utils/temporalAlert', {
        //     show: true,
        //     message: 'Procesado',
        //     type: 'success'
        // })
        store.commit('proyectos/limpiarProyectoState')
        router.push('/proyectos/list').catch(e => {
        })
    } catch (e) {
        if (e.response.status === 400) {
            Vue.$toast.warning(e.response.data.message)
            // state.dispatch('utils/temporalAlert', {
            //     show: true,
            //     message: e.response.data.message,
            //     type: 'warning'
            // })
        }
    }
}

const changeProjectStatusSub = async ({state}, estado) => {
    try {
        await http_client(`/api/v1/proyectos/${state.form_proyecto.id.value}/estados`, {
            id_estado: Number(estado)
        }, 'post')
        Vue.$toast.success('El proyecto ha sido actualizado exitosamente')
        // store.dispatch('utils/temporalAlert', {
        //     show: true,
        //     message: 'El proyecto ha sido actualizado exitosamente',
        //     type: 'success'
        // })
        store.commit('proyectos/limpiarProyectoState')
        router.push('/acquisition/list').catch(e => {

        })
    } catch (e) {
        if (e.response.status === 400) {
            Vue.$toast.warning(e.response.data.message)
            // state.dispatch('utils/temporalAlert', {
            //     show: true,
            //     message: e.response.data.message,
            //     type: 'warning'
            // })
        }
    }
}




const getActividadesProyecto = async ({commit, state}) => {
    try {
        const response = await http_client(`/api/v1/proyectos/${state.form_proyecto.id.value}/actividades`)
        commit('setActivities', response.data)
    } catch (e) {
        if (e.response.status === 403) {
            Vue.$toast.warning('No tiene permiso para listar las partidas del proyecto')
            // this.temporalAlert({
            //     show: true,
            //     type: 'warning',
            //     message: 'No tiene permiso para listar las partidas del proyecto'
            // })
        }
    }
}
const saverActivityArchivo = async ({commit, dispatch, state, rootState},id_proyecto,response_actividad,data = {}) => {
    let dataform = new FormData()
    try {
        dataform.append('adjunto',data[0])
        dataform.append('_method','PUT')
        const response_archivo = await http_client(`/api/v1/proyectos/${id_proyecto}/actividades-memoria-calculos/${response_actividad.id}`,dataform,'post', {
            "Content-Type": "multipart/form-data"
        })
    }catch (e) {
    }
}
const saveActivity = async ({commit, dispatch, state, rootState}, data = {}) => {
    try {
        let typeAccion = 1
        let form = new FormData();
        state.actividad.actividad.message = 'Partida es obligatoria'
        if (Object.keys(data).length === 0) {
            let permiso = true
            Object.keys(state.actividad).forEach(item => {
                if (state.actividad[item].required) {
                    if (state.actividad[item].value !== null && state.actividad[item].value > 0) {
                        commit('setActivityState', {
                            propiedad: item,
                            value: true
                        })
                    } else {
                        permiso = false
                        commit('setActivityState', {
                            propiedad: item,
                            value: false
                        })
                    }
                }
            })
            if (permiso) {
                typeAccion = 2
                form.append('id_actividad', state.actividad.actividad.value);
                form.append('cantidad', state.actividad.cantidad.value);
                form.append('precio_unitario', state.actividad.precio_unitario.value);
                data = {
                    id_actividad: Number(state.actividad.actividad.value),
                    cantidad: Number(state.actividad.cantidad.value),
                    precio_unitario: Number(state.actividad.precio_unitario.value)
                }
            } else return null

        }else {
            Object.keys(data).forEach(item => {
                form.append(item, data[item]);
            })
        }
        dispatch('utils/showLoader', null, {root: true})
        let url = `/api/v1/proyectos/${state.form_proyecto.id.value}/actividades`;
        let method = 'post'
        let message = 'Actividad Registrada'
        if (state.actividad.id.value) {
            url = `/api/v1/proyectos/${state.form_proyecto.id.value}/actividades/${state.actividad.id.value}`
            method = 'put'
            message = 'Actividad Actualizada'
        }

        const headers = {'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'}
        if (typeAccion === 1) {
            form.append('adjunto', state.archivo.value[0]);
        }
        let response
        if (method === 'post') {
            response = await http_client(url, form, method, headers)
        } else if (method === 'put') {
            response = await http_client(url, data, method)
        }
        await dispatch('getActividadesProyecto')
        //if (response.status === 201){
        //  await saverActivityArchivo({},state.form_proyecto.id.value,response.data,state.archivo.value)
        //}
        commit('editActivity', {
            id: null,
            index: null,
            id_actividad: null,
            cantidad: null,
            precio_unitario: null,
            archivo:null
        })
        commit('setCostoTotalPresupuestado', response.data.costo_total_presupuestado)
        dispatch('utils/hideLoader', null, {root: true})
        Vue.$toast.success(message)
        // dispatch('utils/temporalAlert', {
        //     show: true,
        //     type: 'success',
        //     message: message
        // }, {root: true})
        Object.keys(state.actividad).forEach(item => {
            if (state.actividad[item].required) {
                commit('setActivityState', {
                    propiedad: item,
                    value: null
                })
            }
        })
    } catch (e) {
        dispatch('utils/hideLoader', null, {root: true})
        if (e.response.status === 303) {
            state.actividad.actividad.state = false
            state.actividad.actividad.message = 'Partida ya existe'
            Vue.$toast.warning('Partida ya existe')
            // dispatch('utils/temporalAlert', {
            //     show: true,
            //     type: 'warning',
            //     message: 'Partida ya existe'
            // }, {root: true})
        } else if (e.response.status === 400) {
            Vue.$toast.error('Información enviada no valida')
            // dispatch('utils/temporalAlert', {
            //     show: true,
            //     type: 'danger',
            //     message: 'Información enviada no valida'
            // }, {root: true})
        }
    }
}

const removeActivity = async ({dispatch, commit, state}, item) => {
    try {
        dispatch('utils/showLoader', null, {root: true})
        await http_client(`/api/v1/proyectos/${state.form_proyecto.id.value}/actividades/${item.id}`, {}, 'delete')
        commit('removeActivity', item.index)
        Vue.$toast.success('Eliminado')
        // dispatch('utils/temporalAlert', {
        //     show: true,
        //     type: 'success',
        //     message: 'Eliminado'
        // }, {root: true})
    } catch (e) {
        if (e.response.status === 404 || e.response.status === 400) {
            Vue.$toast.warning(e.response.data.message)
            // dispatch('utils/temporalAlert', {
            //     show: true,
            //     type: 'warning',
            //     message: e.response.data.message
            // }, {root: true})
        }
    } finally {
        dispatch('utils/hideLoader', null, {root: true})
    }
}

const getObservacionesByProyect = async ({commit, dispatch}, id_proyecto) => {
    try {
        const response = await http_client(`/api/v1/proyectos/${id_proyecto}/observaciones`)
        commit('setObservacionesByProyect', response.data)
    } catch (e) {
        if (e.response.status === 400) {
            Vue.$toast.warning(e.response.data.message)
            // dispatch('utils/temporalAlert', {
            //     show: true,
            //     type: 'warning',
            //     message: e.response.data.message
            // }, {root: true})
        }
    }
}

const getCategoriasAceptadas = async ({commit}, id_proyecto) => {
    try {
        const response = await http_client(`/api/v1/proyectos/${id_proyecto}/carpeta-documentos/aceptadas`)
        commit('setCategoriasAceptadas', response.data)
    } catch (e) {

    }
}

export {
    nextStepper,
    backStepper,
    guardarProyectoDocs,
    getProyecto,
    showCreatePerson,
    hideCreatePerson,
    setPorcentaje,
    changeStateProyect,
    getPlazos,
    getActividadesProyecto,
    saveActivity,
    removeActivity,
    getEmailResonsable,
    saveEmailResponsable,
    getObservacionesByProyect,
    getCategoriasAceptadas,
    changeProjectStatusSub
}
